<template>
  <div class="hm-mp-list" :class="{ 'hm-mp-list--error': error }">
    <button
      v-for="mp in mealPlanTypes"
      :key="mp.code"
      type="button"
      class="hm-mp-list__item"
      :class="{ 'hm-mp-list__item--active': mp.code === value.code }"
      :style="{
        color: mp.color,
        backgroundColor: pale(mp.color)
      }"
      @click="select(mp)"
    >
      {{ mp.name }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'HMMealPlanList',
  props: {
    value: { type: Object, default: () => ({}) },
    mealPlanTypes: { type: Array, required: true },
    error: { type: Boolean, default: false }
  },
  methods: {
    select(val) {
      if (val.code !== this.value.code) this.$emit('input', val)
    },
    pale(hex) {
      const { r, g, b } = this.hexToRgb(hex)
      return `rgba(${r}, ${g}, ${b}, 0.12)`
    },
    hexToRgb(hex) {
      const clean = hex.replace('#', '')
      const full = clean.length === 3 ? clean.split('').map(c => c + c).join('') : clean
      const n = parseInt(full, 16)
      const r = (n >> 16) & 255
      const g = (n >> 8) & 255
      const b = n & 255
      return { r, g, b }
    }
  }
}
</script>

<style scoped>
.hm-mp-list {
  display: flex;
  align-items: center;
  gap: 15px;
}

.hm-mp-list__item {
  width: 46px;
  height: 24px;
  flex-shrink: 0;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 15px;
  font-weight: 400;
  line-height: 1;
  text-align: center;
  cursor: pointer;
  user-select: none;
  border: 1px solid transparent;
  padding: 0;
  background: transparent;
  outline: none;
}

.hm-mp-list__item--active {
  border: 1px solid rgba(0, 0, 0, 0.40);
}

.hm-mp-list--error .hm-mp-list__item {
  border: 1px solid #f36161;
}
</style>
